"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _graphql = require("../graphql");

var useAuthStub = function useAuthStub() {
  return {
    loading: false,
    authenticated: false
  };
};
/**
 * Redwood's Provider is a zeroconf way to tie together authentication and
 * GraphQL requests.
 *
 * When the `useAuth` hook from `@redwoodjs/auth` is available the authentication
 * token is automatically added to the Authorization headers of each GraphQL request.
 */


var RedwoodProvider = function RedwoodProvider(_ref) {
  var _ref$useAuth = _ref.useAuth,
      useAuth = _ref$useAuth === void 0 ? window.__REDWOOD__USE_AUTH || useAuthStub : _ref$useAuth,
      children = _ref.children;

  var _useAuth = useAuth(),
      loading = _useAuth.loading,
      authenticated = _useAuth.authenticated,
      getToken = _useAuth.getToken,
      type = _useAuth.type;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      authToken = _useState2[0],
      setAuthToken = _useState2[1];

  (0, _react.useEffect)(function () {
    if (authenticated) {
      getToken().then(function (token) {
        return setAuthToken(token);
      });
    }
  }, [authenticated, getToken]); // This really sucks because rendering is completely blocked whilst we're
  // restoring authentication.

  if (loading) {
    return null;
  } // If we have an authToken then modify the headers of the GraphQL client.
  // TODO: Add a way for user's to pass in custom headers to GraphQL, or just a custom client.


  var client = authToken ? (0, _graphql.createGraphQLClient)({
    headers: {
      // Used by `api` to determine the auth type.
      'auth-provider': type,
      authorization: "Bearer ".concat(authToken)
    }
  }) : undefined;
  return /*#__PURE__*/_react.default.createElement(_graphql.GraphQLProvider, {
    client: client
  }, children);
};

var _default = RedwoodProvider;
exports.default = _default;